"use client";

import { useState } from "react";
import { setLocaleCookie } from "@/lib/actions";
import { switchLanguage } from "./paths";

export function useLanguageSwitch(userId?: string) {
  const [pending, setPending] = useState(false);
  const changeLanguage = async (locale: HrefLang) => {
    if (pending) return;
    setPending(true);
    try {
      await setLocaleCookie({ locale, userId });
    } catch (error) {
      console.error("Could not save language preference", error);
    }
    // The explicit URL remains usable even if saving the preference fails.
    window.location.assign(
      switchLanguage(
        window.location.pathname + window.location.search + window.location.hash,
        locale
      )
    );
  };
  return { pending, changeLanguage };
}
